import { ReactElement, useState, MouseEvent } from "react"
import { BsJustify } from "react-icons/bs"
import Button from "@mui/material/Button"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { styled } from "@mui/material"
import { useTranslation } from "../TranslationProvider"

// Function to navigate to different sections of the page
export const navigateTo = (
  sectionId: string,
  location: ScrollLogicalPosition = "center"
): void => {
  const element = document.querySelector(sectionId)

  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: location,
    })
  }
}

export default function DropDownMenu(): ReactElement {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const open = Boolean(anchorEl)

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        style={{ padding: 0, minWidth: 0 }}
        onClick={handleClick}>
        <StyledButtonIcon size={46} color={"#f2f2eb"} />
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}>
        <MenuItem
          onClick={() => {
            handleClose()
            navigateTo("#home")
          }}>
          {t("navigation.home")}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose()
            navigateTo("#whyBookUs")
          }}>
          {t("navigation.whyBook")}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose()
            navigateTo("#promovideo1")
          }}>
          {t("navigation.promovideo1")}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose()
            navigateTo("#instagram")
          }}>
          {"Instagram"}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose()
            navigateTo("#loveDiscoCruise")
          }}>
          {"Love & Disco Cruise"}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose()
            navigateTo("#repertoire")
          }}>
          {t("navigation.repertoire")}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose()
            navigateTo("#promovideo2")
          }}>
          {t("navigation.promovideo2")}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose()
            navigateTo("#footer", "start")
          }}>
          {t("navigation.contact")}
        </MenuItem>
      </Menu>
    </div>
  )
}

const StyledButtonIcon = styled(BsJustify)`
  padding: 0.5em;
  border-radius: 0.5rem;
  box-shadow: 0.1rem 0.1rem 0.3rem black;

  background-color: var(--primary);

  :hover {
    scale: 1.1;
  }
`
